import React from 'react';
import { Route } from 'react-router-dom';
import Login from 'pages/login/index';

const getUnprotectedRoutes = (): JSX.Element[] => [
  <Route key="login" path="/login">
    <Login />
  </Route>,
];

export default getUnprotectedRoutes;
